module.exports = __webpack_public_path__ + "static/media/org-icon.f746e541.svg";